import {
  appendServiceNameToURL,
  appendServicePortToURL,
} from '../../../../Api/resources/serviceURLs';
import { serviceName } from '../../../../Api/resources/serviceConstants';
import { EDR_ACTIVITY_REPORTS } from '../../../../Api/resources/endPoint';

export const getEdrActivityReportBaseURL = () => {
  const serviceURL = appendServiceNameToURL(serviceName.PROJECT_MS);
  const servicePort = appendServicePortToURL(serviceName.PROJECT_MS);
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

  if (process.env.NODE_ENV === 'production') {
    return `${baseUrl}${serviceURL}/api${EDR_ACTIVITY_REPORTS}`;
  }

  return `${baseUrl}:${servicePort}${serviceURL}/api${EDR_ACTIVITY_REPORTS}`;
};
